import config from "../config";
import request, { requestOptions } from "../utils/request";

const baseUrl = `${config.API_ROOT}/integrations`;

const Cloudbeds = {
  async cloudbedsCode(code) {
    const options = await requestOptions("POST", { code }, true);
    const url = `${baseUrl}/cloudbeds`;
    return request(url, options);
  },
  async cloudbedsPreviewCode(code) {
    const options = await requestOptions("POST", { code });
    const url = `${baseUrl}/cloudbeds-preview`;
    return request(url, options);
  },
  async cloudbedsOnboarding(code) {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/cloudbeds-onboarding`;
    return request(url, options);
  },
  async getIntegrations() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/`;
    return request(url, options);
  },
  async list() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/list`;
    return request(url, options);
  },
  async toggle({ connection, integration, action }) {
    const options = await requestOptions(
      "PUT",
      { connection, integration, action },
      true
    );
    const url = `${baseUrl}/toggle-connection`;
    return request(url, options);
  },
  async updateWebchatSettings({
    bubbleColor,
    launchMode,
    whatsappConnectionId,
    desktopWidth,
    desktopHeight,
    mobileWidth,
    mobileHeight,
  }) {
    const options = await requestOptions(
      "PUT",
      {
        bubbleColor,
        launchMode,
        whatsappConnectionId,
        desktopWidth,
        desktopHeight,
        mobileWidth,
        mobileHeight,
      },
      true,
    );
    const url = `${baseUrl}/webchat-settings`;
    return request(url, options);
  },
  async connectMeta({ meta }) {
    const options = await requestOptions("POST", { meta }, true);
    const url = `${baseUrl}/connect-meta`;
    return request(url, options);
  },
  async addDbIntegration({ integration, form }) {
    const options = await requestOptions("POST", { integration, form }, true);
    const url = `${baseUrl}/add-db-integration`;
    return request(url, options);
  },
  async deleteIntegration({ connection, integration }) {
    const options = await requestOptions("POST", { connection, integration }, true);
    const url = `${baseUrl}/delete-integration`;
    return request(url, options);
  },
  async addShopifyIntegration(code) {
    const options = await requestOptions("POST", { code }, true);
    const url = `${baseUrl}/add-shopify-integration`;
    return request(url, options);
  },
  async stripeConnectLink() {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/stripe/connect-link`;
    return request(url, options);
  },
  async stripeLoginLink() {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/stripe/login-link`;
    return request(url, options);
  },
  async stripeDisconnect() {
    const options = await requestOptions("POST", {}, true);
    const url = `${baseUrl}/stripe/disconnect`;
    return request(url, options);
  },
};

export default Cloudbeds;
